import { ScrollArea } from "@/components/ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Data from "./GraphTabs/Data";
import Domain from "./GraphTabs/Domain";
import Display from "./GraphTabs/Display";
import AdvancedOptions from "./GraphTabs/AdvancedOptions";
import { useContext, useState } from "react";
import AuthContext from "@/store/contexts/AuthContext";
import { toast } from "sonner";
import TableBlockDisplay from "./GraphTabs/TableBlockDisplay";
import SqlData from "./GraphTabs/SqlData";
import GraphConfigFormContext from "@/store/contexts/GraphConfigFormContext";
import { useTranslation } from "react-i18next";

const GraphConfig = () => {
  const { config } = useContext(GraphConfigFormContext);
  const { user } = useContext(AuthContext);
  const [tab, setTab] = useState("data");
  const { t } = useTranslation();

  const handleTabChange = (value: string) => {
    // if (false && value !== "data" && user.plan === "freemium") {
    //   toast.error(
    //     "You need a subscription to manually config the graph. With the freemium plan you can build your graph with AI."
    //   );
    //   return;
    // }
    setTab(value);
  };

  if (!config) return null;

  return (
    <Tabs
      defaultValue={tab}
      value={tab}
      onValueChange={handleTabChange}
      className="w-full"
    >
      <div className="px-4">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="data">{t("editor.graphConfig.tabs.data")}</TabsTrigger>
          <TabsTrigger
            value="domain"
            disabled={!!config.data_source.sqlRequest}
          >
            {t("editor.graphConfig.tabs.domain")}
            {config.data_source.domain?.length ? (
              <div className="block w-2 h-2 rounded-full bg-blue-500"></div>
            ) : (
              ""
            )}
          </TabsTrigger>
          <TabsTrigger value="display">{t("editor.graphConfig.tabs.display")}</TabsTrigger>
          <TabsTrigger value="advanced_options">{t("editor.graphConfig.tabs.advancedOptions")}</TabsTrigger>
        </TabsList>
      </div>
      <ScrollArea className="h-[calc(100vh-100px)] w-full border-t">
        {!config.data_source.sqlRequest ? (
          <>
            <TabsContent value="data">
              <Data />
            </TabsContent>
            <TabsContent value="domain">
              <Domain />
            </TabsContent>
          </>
        ) : (
          <TabsContent value="data">
            <SqlData />
          </TabsContent>
        )}
        <TabsContent value="display">
          {config.type === "graph" ? <Display /> : <TableBlockDisplay />}
        </TabsContent>
        <TabsContent value="advanced_options">
          <AdvancedOptions />
        </TabsContent>
      </ScrollArea>
    </Tabs>
  );
};

export default GraphConfig;
